import { render, staticRenderFns } from "./ParkingCard.vue?vue&type=template&id=1438011a&scoped=true&"
import script from "./ParkingCard.vue?vue&type=script&lang=js&"
export * from "./ParkingCard.vue?vue&type=script&lang=js&"
import style0 from "./ParkingCard.vue?vue&type=style&index=0&id=1438011a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1438011a",
  null
  
)

export default component.exports